import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons'
import { Button, TableColumnType } from 'antd'
import moment from 'moment'
import React, { ReactElement } from 'react'
import {
  DateTimeFormatSimple,
} from '../../../models/datetime'
import { Dimen } from '../../../models/dimen'

export const Columns = (
  startIndex: number
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      dataIndex: 'order',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '门店名称',
      dataIndex: 'tenantName',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.tenantName ? t.tenantName : '-'
      },
    },
    {
      title: '商品名',
      dataIndex: 'tenantMaterialsName',
      align: 'center',
      width: '12rem',
      ellipsis: true,
      render: (_, t) => {
        return t.tenantMaterialsName ? t.tenantMaterialsName : '-'
      },
    },
    {
      title: '条形码',
      dataIndex: 'barCode',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.barCode ? t.barCode : '-'
      },
    },
    // {/* 新老目录展示方式 spec=>packSpec*/}
    {
      title: '规格',
      dataIndex: 'packSpec',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.packSpec ? t.packSpec : '-'
      },
    },
    {
      title: '剂型',
      dataIndex: 'doseCategory	',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.doseCategory ? t.doseCategory : '-'
      },
    },
    {
      title: '单位',
      dataIndex: 'unit',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return t.unit ? t.unit : '-'
      },
    },
    {
      title: '厂家',
      dataIndex: 'originName',
      align: 'center',
      width: '12rem',
      ellipsis: true,
      render: (_, t) => {
        return t.originName ? t.originName : '-'
      },
    },
    {
      title: '批号',
      dataIndex: 'batchNo',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return t.batchNo ? t.batchNo : '-'
      },
    },
    {
      title: '有效期至',
      dataIndex: 'periodValidity',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.periodValidity
          ? moment(t.periodValidity).format(DateTimeFormatSimple)
          : '-'
      },
    },
    {
      title: '数量',
      dataIndex: 'counts',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return t.splitTag == 1
          ? t.counts + t?.unit + '/' + t?.splitCount + t?.splitUnit
          : t.counts + t?.unit
      },
    },
    {
      title: '柜号',
      dataIndex: 'cabineNo',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return t.cabineNo ? t.cabineNo : '-'
      },
    },
    {
      title: '供货单位',
      dataIndex: 'supplierName',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.supplierName ? t.supplierName : '-'
      },
    },
    {
      title: '入库日期',
      dataIndex: 'inStockTime',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.inStockTime
          ? moment(t.inStockTime).format(DateTimeFormatSimple)
          : '-'
      },
    },
  ]
}
